import api from 'services/api';

/**
 * DELETE `/locks/:zoneName/:lockName`. Locks are addressed by
 * `zone_name | lock_name`. Resolves on success; throws on HTTP error (caller
 * surfaces the message). The 200 body is a `{ message }` acknowledgement with
 * no load-bearing data, so there is nothing to validate or return.
 */
export const deleteLock = async (zoneName: string, name: string): Promise<void> => {
  await api.delete(`/locks/${encodeURIComponent(zoneName)}/${encodeURIComponent(name)}`);
};
